import * as yup from "yup";

// const newPasswordRules = /^(?=.*[A-Z])(?=.*[a-z])(?=.*[\W_]).{8,}$/;
const newPasswordRules = /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[\W_]).{8,}$/;

export const formSchema = yup.object().shape({
  currentPassword: yup.string().required("Required!"),
  newPassword: yup
    .string()
    .min(8)
    .matches(newPasswordRules, {
      message: "**Please create a stronger password",
    })
    .required("Required!"),
  confirmPassword: yup
    .string()
    .oneOf([yup.ref("newPassword"), null], "Password are not matching!")
    .required("Required!"),
});

export const resetPasswordSchema = yup.object().shape({
  newPassword: yup
    .string()
    .min(8)
    .matches(newPasswordRules, {
      message: "**Please create a stronger password",
    })
    .required("Required!"),
  confirmPassword: yup
    .string()
    .oneOf([yup.ref("newPassword"), null], "Password is not matching!")
    .required("Required!"),
});
const emailRegex = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;
export const signupSchema = yup.object().shape({
  firstName: yup
    .string()
    .matches(/^[A-Za-z]+$/, "First name can only contain letters")
    .required("Required!"),
  lastName: yup
    .string()
    .matches(/^[A-Za-z]+$/, "Last name can only contain letters")
    .required("Required!"),
  businessEmail: yup
    .string()
    .email("Please enter a valid email address")
    .required("Required!"),
  password: yup
    .string()
    .min(8)
    .matches(newPasswordRules, {
      message: "**Please create a stronger password",
    })
    .required("Required!"),
});

export const forgotPasswordSchema = yup.object().shape({
  email: yup
    .string()
    .email("Please enter a valid email address")
    .required("Required!"),
});

export const updateAmountSchema = yup.object().shape({
  Amount: yup.string().required("Empty values are not Acceptable!"),
});

export const verifySingleMailSchema = yup.object().shape({
  email: yup
    .string()
    .email("**Please enter a valid email address")
    .required("Please enter valid email"),
});

export const spfDomainSchema = yup.object().shape({
  domain: yup
    .string()
    .matches(/^[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)*\.[a-zA-Z]{2,6}$/, "Domain must end with .com or .in")
    .required("Please enter valid email"),
});

export const verifyBulkMailSchema = yup.object().shape({
  listName: yup.string().required("Please enter a list name"),
  emails: yup
    .array()
    .of(yup.string().email("**Please enter a valid email address"))
    .required("Please enter valid email addresses"),
});

export const createContactFormSchema = yup.object().shape({
  firstName: yup.string().required("required"),
  lastName: yup.string().required("required"),
  email: yup.string().required("required"),
  phoneNumber: yup.string().required("required"),
  listName: yup.string().required("required"),
});

export const signatureBuilderSchema = yup.object().shape({
  name: yup.string().required("First Name is required"),
  lastName: yup.string().required("Last Name is required"),
  jobTitle: yup.string(),
  department: yup.string(),
  company: yup.string(),
  phoneNumber: yup.string().matches(/^[0-9]{10}$/, 'Phone Number must be exactly 10 digits'),
  websiteURL: yup
    .string()
    .url("Invalid URL"),
  emailAddress: yup
    .string()
    .email("Invalid email"),
  businessAddress: yup.string(),
  photoURL: yup.string().url("Invalid URL"),
  linkedin: yup
    .string()
    .url("Invalid URL"),
  facebook: yup
    .string()
    .url("Invalid URL"),
  twitter: yup.string().url("Invalid URL"),
  instagram: yup
    .string()
    .url("Invalid URL")
});

export const toEmailTestSchema = yup.object().shape({
  email: yup.string().required("required"),
  subject: yup.string().required("required"),
  content: yup.string().required("required"),
});
